import * as yup from 'yup'

export const schemaDialogFormAnotherSource = yup.object().shape({
  entityName: yup.string().required(),
})

export default schemaDialogFormAnotherSource
